module.exports = __webpack_public_path__ + "img/1726036070400-screenshot-1726036042911.png.a0e614a6.webp";